"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Faq = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Faq = function Faq(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.397 17.935c-.19.52-.432.983-.718 1.376-.272.38-.572.714-.885.99-.238.208-.442.391-.611.546-.342.333-.654.652-.909.942a3.398 3.398 0 00-.495.706 3.033 3.033 0 00-.262.771 5.724 5.724 0 00-.095 1.13 1.2 1.2 0 01-1.2 1.2h-.435a1.2 1.2 0 01-1.2-1.2c0-.57.042-1.09.129-1.547.087-.47.231-.939.429-1.384.204-.453.476-.893.811-1.314.3-.383.67-.783 1.124-1.224.09-.089.279-.255.554-.48.178-.144.367-.338.562-.575a3.37 3.37 0 00.489-.816c.12-.273.181-.603.181-.98 0-.326-.055-.596-.17-.83a1.638 1.638 0 00-.47-.587 2.4 2.4 0 00-.811-.399c-.809-.238-1.901-.207-2.62.096-.385.162-.69.375-.931.651a2.74 2.74 0 00-.555 1.049 4.655 4.655 0 00-.17 1.53 1.197 1.197 0 01-1.198 1.253h-.435c-.643 0-1.175-.51-1.2-1.154-.033-.906.074-1.75.318-2.511a5.68 5.68 0 011.161-2.061 5.344 5.344 0 011.938-1.37c1.327-.56 3.072-.625 4.521-.184a5.296 5.296 0 011.753.903c.52.41.936.927 1.241 1.533.308.615.462 1.315.462 2.08 0 .69-.1 1.316-.303 1.86zm-6.81 11.597v-.534a1.2 1.2 0 011.2-1.2h.435a1.2 1.2 0 011.2 1.2v.534a1.2 1.2 0 01-1.2 1.2h-.435a1.2 1.2 0 01-1.2-1.2zM33 12a6 6 0 00-6-6H9a6 6 0 00-6 6v18a6 6 0 006 6v4.497c0 1.294 1.53 1.981 2.496 1.122l6.321-5.62H25.5V25.5c0-4.45 3.25-8.146 7.5-8.864V12zm2.657 20.724a1.497 1.497 0 012.119-.07l2.974 2.79 6.975-6.54a1.499 1.499 0 112.05 2.188l-7.998 7.501A1.49 1.49 0 0140.75 39c-.37 0-.737-.135-1.025-.407l-4-3.75a1.497 1.497 0 01-.07-2.12zM51 19.5H34.5a6 6 0 00-6 6V42a6 6 0 006 6h7.683l6.321 5.618c.968.86 2.496.173 2.496-1.122V48a6 6 0 006-6V25.5a6 6 0 00-6-6z",
    fill: "url(#FAQ_svg__FAQ_svg__paint0_linear_17373_95702)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "FAQ_svg__FAQ_svg__paint0_linear_17373_95702",
    x1: 3,
    y1: 54,
    x2: 60.093,
    y2: 49.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.Faq = Faq;
var _default = Faq;
exports.default = _default;